<template>
  <div>
    <div class="app-content content devcontent">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
          <div class="container-fluid">
            <div class="row breadcrumbs-top">
              <div class="col-md-12 content-header-left px-0">
                <h3 class="content-header-title float-left mb-0">
                  Vehicle Scheduling
                </h3>
                <div class="breadcrumb-wrapper">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <router-link to="/mydashboard">
                        Management Details</router-link
                      >
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-body">
          <section>
            <div class="card">
              <div class="card-header px-0 common_top_title_searchbgst_dock">
                <div class="container-fluid">
                  <div class="row row fc_my-05">
                    <div class="w-auto px-1 mobile-padding-0-2">
                      <div
                        class="avatar bg-light-secondary rounded d-inline-flex mr-1"
                      >
                        <div class="avatar-content">
                          <i
                            class="i_icon_st la-people-carry las lab font-medium-5"
                          ></i>
                        </div>
                      </div>
                      <h4 class="card-title d-inline-flex ml-0 mb-0">
                        Vehicle Scheduling
                      </h4>
                    </div>
                    <div class="ml-auto px-1 mobile-padding-0-2">
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="toggleMasterCreate"
                      >
                        Create
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 px-0">
                <div class="card text-center mb-1">
                  <div
                    class="card-card-header text-editar_discription_jobs masters_detailstabing_pills px-0"
                  >
                    <div
                      class="nav-tabs epg-tabs subcategory-tabs no-bg scroll-both"
                    >
                      <nav class="nav-tabs-wrapper main_divtabsview">
                        <ul
                          class="tabs_masters_detailstabing_pills nav nav-pills nav-pill-primary pb-0 nav-tabs-items dragscroll"
                        >
                          <li
                            class="nav-item tabs-item active main_divtabsviewtoggle"
                            data-day="1"
                          ></li>
                        </ul>
                      </nav>
                    </div>

                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane active"
                        id="vehicle_scheduling_form"
                      >
                        <div class="container px-0" v-if="vehicle_scheduling_form">
                          <div class="row mx-0 mt-1">
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                              <label class="form-label text-left w-100"
                                >Vehicle</label
                              >
                              <treeselect
                                placeholder="Select Vehicle"
                                :options="vehicleList"
                                v-model="formData.vehicle_id"
                                @input="handleVehicleChange"
                              />
                            </div>

                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                              <label class="form-label text-left w-100"
                                >Route Path (Route No.)</label
                              >
                              <treeselect
                                placeholder="Select Route Path"
                                :options="routeList"
                                v-model="formData.route_number"
                              />
                            </div>

                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                              <label class="form-label text-left w-100"
                                >Driver Name</label
                              >
                              <input
                                class="form-control"
                                type="text"
                                placeholder="Enter Driver Name  "
                                v-model="formData.driver_name"
                              />
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                              <label class="form-label text-left w-100"
                                >Mobile</label
                              >
                              <input
                                class="form-control"
                                type="text"
                                placeholder="Enter Mobile No  "
                                v-model="formData.mobile"
                              />
                            </div>

                            <div
                              class="pull-right text-right col-12 col-sm-6 col-md-6 col-lg-12 mb-1 common_trs_buttons_res"
                            >
                              <button
                                type="button"
                                class="btn btn-relief-primary common-btn_btn_view"
                                style="margin-top: 18px !important"
                                @click="saveData"
                                :disabled="!validateForm()"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div class="table-responsive datatableview">
                            <table
                              class="table table-striped table-hover table_stickys table-col-td-white custom_doctable"
                            >
                              <thead>
                                <tr>
                                  <!-- <th class="text-left align-middle">Warehouse id</th> -->
                                  <th class="text-left align-middle">
                                    Vehicle
                                  </th>
                                  <th class="text-left align-middle">
                                    Route Path
                                  </th>
                                  <!-- <th class="text-left align-middle">
                                    Driver Photo
                                  </th> -->
                                  <th class="text-left align-middle">
                                    Driver Name
                                  </th>
                                  <th class="text-center align-middle">
                                    Mobile
                                  </th>
                                  <!-- <th class="text-center align-middle">
                                    Upload Photos
                                  </th> -->
                                  <!-- <th class="text-center align-middle">
                                    Photos
                                  </th> -->
                                  <!-- <th class="text-center align-middle">
                                    FIR Copy
                                  </th> -->
                                </tr>
                              </thead>
                              <tbody>
                                <template
                                  v-for="(data, index) of vehicle_scheduling_form.list"
                                >
                                  <tr>
                                    <td data-column="Vehicle" class="text-left">
                                      {{ data.vehicle_id }}
                                    </td>
                                    <td data-column="Vehicle" class="text-left">
                                      {{ data.route_number }}
                                    </td>
                                    <td
                                      data-column="Driver Name"
                                      class="text-left"
                                    >
                                      {{ data.driver_name }}
                                    </td>
                                    <td data-column="Mobile" class="text-left">
                                      {{ data.mobile }}
                                    </td>
                                  </tr>
                                </template>
                              </tbody>
                            </table>
                          </div>
                          <div
                            class="pageCenter text-center mt-4 pagination_viewallpages"
                          >
                            <pagination
                              v-model="vehicle_scheduling_form.page"
                              :records="vehicle_scheduling_form.totalcount"
                              :per-page="vehicle_scheduling_form.pagelimit"
                              @paginate="
                                (e) => handlePageChange(e, 'vehicle_scheduling_form')
                              "
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Pagination from "vue-pagination-2";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Treeselect from "@riophae/vue-treeselect";
import VueElementLoading from "vue-element-loading";
import {
  XCircleIcon,
  FileIcon,
  UploadIcon,
  DownloadIcon,
  EditIcon,
} from "vue-feather-icons";
import CONSTANT from "../constants.js";
import common_methods from "../utils/common_methods";
import searchMasterNameList from "../utils/searchMasterNameList";

export default {
  name: "VehicleScheduling",
  mixins: [common_methods, searchMasterNameList],
  components: {
    Treeselect,
    DatePicker,
    VueElementLoading,
    Pagination,
    UploadIcon,
    FileIcon,
    XCircleIcon,
    DownloadIcon,
    EditIcon,
    Pagination,
  },
  data() {
    return {
      un: "",
      isLoading: false,
      isShipmentsSyncing: false,
      isMasterListLoading: true,
      pagefeatures: [],
      isFormEdit: false,
      vehicleList: [],
      vehiclesRouteNumerList: [],
      routeList: [],
      vehicle_scheduling_form: {
        url: "/accident",
        list: [],
        totalcount: 0,
        pageCount: 0,
        page: 1,
        pagelimit: CONSTANT.LIMIT,
        currPageNum: 0,
        pageoffset: 1,
        presignedUrls: [],
      },
      formData: {
        vehicle_id: null,
        route_number: null,
        mobile: null,
        driver_name: null,
      },
    };
  },
  created() {
    this.getScheduledVehicleList();
  },
  mounted() {},
  methods: {
    saveData() {
      if (!this.validateForm()) {
        this.sweetAlertSnackbar(
          "Form was invalidated. Make sure that all reuired fields are filled out!",
          "error"
        );
        return;
      }
      let payload = this.formData;
      let method = "POST";
      let url = "/vehicles/scheduled/create";
      axios({
        method,
        url,
        data: payload,
      })
        .then((result) => {
          this.isLoading = false;
          this.resetform();
          if (result && result.data && result.data.status) {
            this.sweetAlertSnackbar(result.data.message, "success");
          } else {
            this.sweetAlertSnackbar(result.data.message, "error");
          }
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    validateForm() {
      let isValid = true;
      if (!this.formData.vehicle_id) {
        isValid = false;
      }
      if (!this.formData.route_number) {
        isValid = false;
      }
      if (!this.formData.driver_name) {
        isValid = false;
      }
      if (!this.formData.mobile) {
        isValid = false;
      }

      return isValid;

    },
    resetform() {
      this.formData.vehicle_id = null
      this.formData.route_number = null
      this.formData.driver_name = null
      this.formData.mobile_number = null
    },
    toggleMasterCreate() {
      if (this.isFormEdit) {
        this.resetform("vehicle_scheduling_form");
      }
      this.isFormEdit = false;
      this.vehicle_scheduling_form = !this.vehicle_scheduling_form;
    },
    getScheduledVehicleList() {
      this.makeRequest(
        "GET",
        "/vehicles/scheduled/list",
      )
        .then((result) => {
          this.vehicleList = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    getMasterList(tab = "vehicle_scheduling_form") {
      this.isMasterListLoading = true;
      let url = this[tab].url;
      let method = "POST";
      let payload = {
        page: this[tab].page,
        rows: this[tab].pagelimit,
      };
      this.makeRequest(method, url, payload)
        .then((result) => {
          this.isMasterListLoading = false;
          this[tab].list = result.data.data.rows;
          this[tab].totalcount = result.data.data.count;
          this[tab].pageCount = Math.ceil(
            result.data.data.count / this[tab].pagelimit
          );
        })
        .catch((e) => {
          this.isMasterListLoading = false;
          this.displayError(e);
        });
    },
    getRouteNumbers(id) {
      this.makeRequest(
        "GET",
        `/vehicles/scheduled/${id}/route-list`
      )
        .then((result) => {
          this.routeList = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    handleVehicleChange(id) {
      this.formData.route_number = null;
      if (id) {
        this.getRouteNumbers(id)
      } else {
        this.routeList = [];
      }
    },
    handlePageChange(pageNum, tab) {
      this[tab].pageoffset = pageNum;
      this[tab].currPageNum = pageNum - 1;

      this.getMasterList(tab);
      setTimeout(() => {
        $("html, body").animate({
          scrollTop: $(`#${tab}`).offset().top - 70,
        });
      }, 500);
    },
  },
};
</script>
<style scoped>

.requiredField {
  margin-left: 2px;
  color: red;
}

</style>
